import { styleGuideColors } from "../../../mocks/inspirations";

export default function SGColorSection() {
  return (
    <section id="guide-start" className="py-28 px-8 md:px-16 max-w-screen-xl mx-auto border-t border-[#EDE6DA]">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
        {/* Image — left */}
        <div className="relative order-2 lg:order-1">
          <div className="rounded-2xl overflow-hidden aspect-[4/5] bg-[#F5F1E8]">
            <img
              src="https://public.readdy.ai/ai/img_res/6fec8e7dff5b0c2fbc97e5ba69dbdc7a.jpg"
              alt="Neutral color palettes"
              className="w-full h-full object-cover object-top"
            />
          </div>
          {/* Color swatch strip — floating */}
          <div className="absolute -bottom-6 right-0 bg-[#FAF7F0] rounded-2xl p-5 flex gap-2.5 items-center">
            {styleGuideColors.map((c) => (
              <div key={c.hex} className="group cursor-pointer">
                <div
                  className="w-8 h-8 rounded-full border border-[#EDE6DA] transition-transform duration-200 group-hover:scale-110"
                  style={{ backgroundColor: c.hex }}
                  title={c.name}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Text — right */}
        <div className="order-1 lg:order-2">
          <div className="flex items-center gap-3 mb-7">
            <span
              className="text-[#D9CEBC] text-6xl leading-none"
              style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700 }}
            >
              01
            </span>
            <span className="flex-1 h-px bg-[#EDE6DA]" />
          </div>

          <p
            className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-4"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Color Palette
          </p>

          <h2
            className="text-[#2C2825] text-3xl md:text-4xl leading-snug mb-6"
            style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
          >
            Neutral Color<br />
            <em>Palettes</em>
          </h2>

          <p
            className="text-[#6B5E53] text-base leading-relaxed mb-8 max-w-sm"
            style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
          >
            Explore beige, ivory, cream, taupe, and warm white combinations for a softer home look.
            These muted tones create harmony and calm in every room.
          </p>

          {/* Color list */}
          <div className="space-y-3 mb-10">
            {styleGuideColors.map((color) => (
              <div key={color.name} className="flex items-center gap-4">
                <div
                  className="w-5 h-5 rounded-full flex-shrink-0 border border-[#D9CEBC]"
                  style={{ backgroundColor: color.hex }}
                />
                <div className="flex items-baseline gap-3">
                  <span
                    className="text-[#2C2825] text-sm"
                    style={{ fontFamily: "'Inter', sans-serif", fontWeight: 500 }}
                  >
                    {color.name}
                  </span>
                  <span
                    className="text-[#C8BAA8] text-xs"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    {color.hex}
                  </span>
                  <span
                    className="text-[#A89A8E] text-xs"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    — {color.desc}
                  </span>
                </div>
              </div>
            ))}
          </div>

          <button
            className="inline-flex items-center gap-2 border border-[#C8BAA8] text-[#6B5E53] px-7 py-3 rounded-full text-xs tracking-[0.14em] hover:bg-[#2C2825] hover:text-white hover:border-[#2C2825] transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            See Color Ideas
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-arrow-right-line text-[10px]" />
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}
